module.exports = __webpack_public_path__ + "assets/icon-chart-growing-round-bars-bubble-component.3aff8154.svg";